import withState from 'recompose/withState';

const enhance = (defaultValue = false) => withState('sendNotifications', 'setSendNotifications', defaultValue);

export default enhance;
